export default {"src":"/_next/static/media/WhoWeAre_047A.6977a7c9.JPG","height":696,"width":1920};